<template lang="pug">
  v-layout(row wrap)
    v-flex(xs12 sm12 md12 lg12)
      v-layout.subheader-policyinfo(row wrap)
        v-flex.first(xs12 sm12 md6 lg6)
          v-layout(row wrap)
            v-flex(xs2 sm2 md1 lg1)
              img.icon-cliente(:src="icons.cliente" alt="icons-cliente")
            v-flex.text-client-policy(xs10 sm10 md11 lg11)
              h2 {{ title }}
              p Este es el resumen de tu póliza
        //- v-flex.global-info-policy(xs12 sm12 md6 lg6 v-if="$vuetify.breakpoint.mdAndUp")
          p
            strong Número de póliza:
            br.hidden-md-and-up
            |  {{ annuity.numeroPoliza }}
          p
            strong Inicio de vigencia:
            br.hidden-md-and-up
            |  {{ annuity.fechaVigencia }}
    form-desktop-rentas(:annuity="annuity" v-if="$vuetify.breakpoint.mdAndUp")
    form-mobile-rentas(:annuity="annuity" v-if="$vuetify.breakpoint.smAndDown")
    //- v-flex.hidden-sm-and-down(md5 lg5)
      //- DATOS DEL ASEGURADO
      .contain-box-asegurado
        .box-icon-asegurado
          img(:src="icons.asegurado" alt="icon-asegurado")
        .box-text-asegurado
          span Mi beneficiario (a)
          p {{ annuity.asegurado }}
      //- DATOS DEL AGENTE
      .contain-box-agente
        .box-icon-agente
          img.icon-agente(:src="icons.agente" alt="icons-cliente")
        .box-text-agente
          span Servicio al cliente
          p.name-agente Call: 500-0000
          //- p.name-agente(v-if="annuity.nombreAgenteMantenimiento") {{ annuity.nombreAgenteMantenimiento }}
          //- p.name-agente(v-else) {{ annuity.nombreAgente }}
          p.email-agente(v-on:click="sendMailTo")
            img.icon-cliente(:src="icons.correo" alt="icons-correo")
            //- span {{ annuity.emailAgente }}
            span servicios@interseguro.com.pe
      //- DESCARGAS
      .contain-poliza-electronica
        h3 Descargas
        .box-btn-descargar
          p Póliza
          v-btn(type='button' @click="downloadPDFs('polizas', null)")
            img(:src="icons.descargar" :srcset="icons.descargar" alt="iconDownload")
        //- USERS RPP HAVEN'T CONSTANCIA JUBILACION
        .box-btn-descargar(v-if="downConstjubil")
          p Constancia de jubilación
          v-btn(type='button' @click="downloadPDFs('constancia-jubila', null)")
            img(:src="icons.descargar" :srcset="icons.descargar" alt="iconDownload")
        .box-btn-descargar(v-if="downCronPagos === true" v-for="(pdfLoan, index) in listPdfLoan" :key="index")
          p Cronograma de Pago Prestamo {{ pdfLoan.codigoPrestamo }}
          v-btn(type='button' @click="downloadPDFs('cronograma-pago-prestamos', pdfLoan.nombreArchivo)")
            img(:src="icons.descargar" :srcset="icons.descargar" alt="iconDownload")
        //- CRONOGRAMA DE PAGOS PARA RVI y RPP
        .box-btn-descargar(v-if="(annuity.tipoPension != null && annuity.tipoPension.includes('JUBILACIÓN')) || annuity.codigoProducto=='RPP'")
          p Cronograma de Pago Rentas
          v-btn(v-if="(annuity.tipoPension != null && annuity.tipoPension.includes('JUBILACIÓN'))" type='button' @click="downloadPDFs('cronograma-rvi', null)")
            img(:src="icons.descargar" :srcset="icons.descargar" alt="iconDownload")
          v-btn(v-else-if="annuity.codigoProducto=='RPP'" type='button' @click="downloadPDFs('cronograma-rpp', null)")
            img(:src="icons.descargar" :srcset="icons.descargar" alt="iconDownload")
      //- DESCARGAR BOLETAS DE PENSION
      v-expansion-panel(v-model="panel" expand)
        v-expansion-panel-content
          template(v-slot:header="")
            div Histórico de pagos
          v-card
            v-card-text
              .contain-box-pagos
                v-layout(row wrap)
                  v-flex.flex-selected-year(xs12 sm12)
                    v-select(v-model='selectedYear' :items='items' label='Año' append-icon="expand_more")
                  v-flex.history-payments-list(xs12 sm12 v-for="(payment, index) in historyPayments" :key='index' v-if="parseInt(payment.fecProcesoPago.split('-')[0]) === selectedYear")
                    v-list
                      // v-list-tile(v-on:click="getPDFPagos($event, payment.enlace)")
                      v-list-tile(v-on:click="getPDFPagos($event, parseInt(payment.idBenPagos))")
                        v-list-tile-content
                          v-list-tile-title {{ payment.fecProcesoPago.split('-')[0] }} - {{ payment.fecProcesoPago.split('-')[1] }}
                        v-list-tile-action
                          v-btn(icon ripple)
                            img(src="@/assets/icons/boton-descarga-historico-pago.svg" srcset="@/assets/icons/boton-descarga-historico-pago.svg" alt="boton-descarga-historico-pago")
    //- v-flex.hidden-sm-and-down(md1 lg1)
    //- v-flex(xs12 sm12 md6 lg6)
      .box-fondo-actual
        //- CAMBIO RPP/IFP
        p.main-pago-totalp.main-pago-total(v-if="annuity.codigoProducto != 'RPP' && annuity.codigoProducto != 'IFP'")
          span
            img.icon-cliente(:src="icons.pago" alt="icons-pago")
            | Neto a Pagar
          strong
            | {{ currency }} {{ (Math.round(parseFloat(annuity.netoPago) * 100) / 100).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,') }}
        p.main-pago-totalp.main-pago-total(v-else-if="(annuity.codigoProducto === 'RPP' || annuity.codigoProducto === 'IFP') && annuity.ingresosDobles > 0")
          span
            img.icon-cliente(:src="icons.pago" alt="icons-pago")
            | Renta Doble a Pagar
          strong
            | {{ currency }} {{ (Math.round(parseFloat(annuity.netoPago) * 100) / 100).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,') }}
        p.main-pago-totalp.main-pago-total(v-else-if="(annuity.codigoProducto === 'RPP' || annuity.codigoProducto === 'IFP') && annuity.ingresosDobles < 1")
          span
            img.icon-cliente(:src="icons.pago" alt="icons-pago")
            | Renta a Pagar
          strong
            | {{ currency }} {{ (Math.round(parseFloat(annuity.netoPago) * 100) / 100).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,') }}
      //- PARA RENTAS NO RPP / IFP
      ul.list-datos-vida(v-if="annuity.codigoProducto!= 'RPP' && annuity.codigoProducto!= 'IFP'")
        //- li
          p.list-title
            img(:src="icons.frecuenciaPago" alt="icons-frecuencia-pago")
            span Fecha de último pago
          p.list-data {{ annuity.fechaPago }}
        li
          p.list-title
            img(:src="icons.frecuenciaPago" alt="icons-frecuencia-pago")
            span Tipo de moneda
          p.list-data {{ (annuity.primaProgramadaMoneda.includes('S/') || this.annuity.primaProgramadaMoneda.includes('NUEVO SOL') || this.annuity.primaProgramadaMoneda.includes('Soles')) ? 'Nuevos Soles' : 'Dolares' }}
        li
          p.list-title
            img(:src="icons.pagadoHasta" alt="icons-pagado-hasta")
            span Tipo de pensión
          p.list-data {{ annuity.tipoPension }}
        li
          p.list-title
            img(:src="icons.coberturaPrincipal" alt="icons-cobertura-principal")
            span Modalidad
          p.list-data {{ annuity.modalidad }}
      //- PARA RENTAS RPP / IFP
      ul.list-datos-vida(v-else)
        li(v-if="annuity.ingresosDobles > 0")
          p.list-title
            img(:src="icons.frecuenciaPago" alt="icons-frecuencia-pago")
            span Periodicidad Pago Doble
          p.list-data {{ additional.periocidadDiferido }} - {{ additional.periocidadDobles }}
        li
          p.list-title
            img(:src="icons.frecuenciaPago" alt="icons-frecuencia-pago")
            span Periodicidad Pago Mensual
          p.list-data(v-if="annuity.ingresosDobles > 0") {{ additional.periocidadDoblesSiguiente }} - {{ additional.periocidadMensual }}
          p.list-data(v-else) {{ additional.periocidadDobles }} - {{ additional.periocidadMensual }}
        li
          p.list-title
            img(:src="icons.frecuenciaPago" alt="icons-frecuencia-pago")
            span Monto de Devolución
          p.list-data {{ currency }} {{ annuity.montoDevolucion.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,') }}
    //- ONLY FOR MOBILE
    //-v-flex#data-asegurado-agente(xs12 sm12 v-if="$vuetify.breakpoint.smAndDown")
      //- DATOS DEL ASEGURADO
      .contain-box-asegurado
        .box-icon-asegurado
          img(:src="icons.asegurado" alt="icon-asegurado")
        .box-text-asegurado
          span Mi beneficiario (a)
          p {{ annuity.asegurado }}
      //- DATOS DEL AGENTE
      .contain-box-agente
        .box-icon-agente
          img.icon-agente(:src="icons.agente" alt="icons-cliente")
        .box-text-agente
          span Servicio al cliente
          p.name-agente Call: 500-0000
          p.email-agente(v-on:click="sendMailTo")
            img.icon-cliente(:src="icons.mensajeAgente" alt="icons-mensajeAgente")
            span ENVIAR CORREO AL CALL CENTER
      //- DESCARGAR POLIZA
      .contain-poliza-electronica
        h3 Descargas
        .box-btn-descargar
          p Póliza
          v-btn(type='button' @click="downloadPDFs('polizas', null)")
            img(:src="icons.descargar" :srcset="icons.descargar" alt="iconDownload")
        .box-btn-descargar(v-if="downConstjubil")
          p Constancia de jubilación
          v-btn(type='button' @click="downloadPDFs('constancia-jubila', null)")
            img(:src="icons.descargar" :srcset="icons.descargar" alt="iconDownload")
        .box-btn-descargar(v-if="downCronPagos === true" v-for="(pdfLoan, index) in listPdfLoan" :key="index")
          p Cronograma de Pago Prestamo {{ pdfLoan.codigoPrestamo }}
          v-btn(type='button' @click="downloadPDFs('cronograma-pago-prestamos', pdfLoan.nombreArchivo)")
            img(:src="icons.descargar" :srcset="icons.descargar" alt="iconDownload")
        //- CRONOGRAMA DE PAGOS PARA RVI y RPP
        .box-btn-descargar(v-if="(annuity.tipoPension != null && annuity.tipoPension.includes('JUBILACIÓN')) || annuity.codigoProducto=='RPP'")
          p Cronograma de Pago Rentas
          v-btn(v-if="(annuity.tipoPension != null && annuity.tipoPension.includes('JUBILACIÓN'))" type='button' @click="downloadPDFs('cronograma-rvi', null)")
            img(:src="icons.descargar" :srcset="icons.descargar" alt="iconDownload")
          v-btn(v-else-if="annuity.codigoProducto=='RPP'" type='button' @click="downloadPDFs('cronograma-rpp', null)")
            img(:src="icons.descargar" :srcset="icons.descargar" alt="iconDownload")
      //- DESCARGAR BOLETAS DE PENSION
      v-expansion-panel(v-model="panel" expand)
        v-expansion-panel-content
          template(v-slot:header="")
            div Histórico de pagos
          v-card
            v-card-text
              .contain-box-pagos
                v-layout(row wrap)
                  v-flex.flex-selected-year(xs12 sm12)
                    v-select(v-model='selectedYear' :items='items' label='Año' append-icon="expand_more")
                  v-flex.history-payments-list(xs12 sm12 v-for="(payment, index) in historyPayments" :key='index' v-if="parseInt(payment.fecProcesoPago.split('-')[0]) === selectedYear")
                    v-list
                      // v-list-tile(v-on:click="getPDFPagos($event, payment.enlace)")
                      v-list-tile(v-on:click="getPDFPagos($event, parseInt(payment.idBenPagos))")
                        v-list-tile-content
                          v-list-tile-title {{ payment.fecProcesoPago.split('-')[0] }} - {{ payment.fecProcesoPago.split('-')[1] }}
                        v-list-tile-action
                          v-btn(icon ripple)
                            img(src="@/assets/icons/boton-descarga-historico-pago.svg" srcset="@/assets/icons/boton-descarga-historico-pago.svg" alt="boton-descarga-historico-pago")
</template>

<!-- eslint-disable -->
<script>
import { mapGetters } from 'vuex'
import FormDesktopRentas from '@/components/rentas/FormDesktopRentas'
import FormMobileRentas from '@/components/rentas/FormMobileRentas'

export default {
  data () {
    return {
      title: '',
      icons: {
        cliente: require('./../assets/vida-icons/icon-cliente.svg')
      }
    }
  },
  props: ['annuity'],
  computed: {
    ...mapGetters('user', ['historyPayments', 'userInfo'])
  },
  mounted () {
    this.title = 'Hola ' + this.userInfo.nombreUsuario
  },
  components: {
    'form-desktop-rentas': FormDesktopRentas,
    'form-mobile-rentas': FormMobileRentas
  }
}
</script>

<style>
  /** ESTILO 3 */
  #annuity-content .container.grid-list-md {
    padding-top: 0;
    padding-bottom: 0;
  }
  .subheader-policyinfo {
    border-bottom: #DEDEDE 1px solid;
    margin-bottom: 2em !important;
    padding-bottom: 10px;
  }
  .subheader-policyinfo img.icon-cliente {
    width: 37px;
    position: relative;
    top: 10px;
  }
  .subheader-policyinfo .text-client-policy { padding-left: 11px !important; }
  .subheader-policyinfo .flex h2 {
    font-size: 28px;
    line-height: 1.2;
  }
  .subheader-policyinfo .flex h2, .subheader-policyinfo .flex p strong {
    color: #1F1F1F;
    font-weight: normal;
  }
  .subheader-policyinfo .flex p strong { font-family: 'Omnes Medium' }
  .subheader-policyinfo .flex p {
    color: #717285;
    margin-bottom: 0;
  }
  .layout.subheader-policyinfo .flex.global-info-policy {
    text-align: right;
    padding-top: 39px;
  }
  .subheader-policyinfo .global-info-policy p { display: inline-block; }
  .subheader-policyinfo .global-info-policy p:first-child { margin-right: 3em; }
  .contain-box-asegurado p img {
    width: 44px;
    margin-right: 30px;
  }
  .contain-box-asegurado p {
    color: #717285;
  }
  .contain-box-asegurado { border-top: #DEDEDE 1px solid; }
  .contain-box-agente {
    border-top: #DEDEDE 1px solid;
    border-bottom: #DEDEDE 1px solid;
  }
  .contain-box-agente p.email-agente {
    display: block;
    cursor: pointer;
  }
  .contain-box-agente p.email-agente img {
    width: 18px;
    margin-right: 10px;
  }
  .contain-box-agente, .contain-box-asegurado {
    clear: both;
    overflow: hidden;
    padding-top: 2em;
    padding-bottom: 5px;
  }
  .contain-box-agente .box-icon-agente, .contain-box-asegurado .box-icon-asegurado {
    float: left;
    width: 13%;
  }
  .contain-box-agente .box-text-agente p.email-agente span { color: var(--first-brand-color); }
  .contain-box-agente .box-text-agente span, .contain-box-asegurado .box-text-asegurado span {
    font-family: 'Omnes Medium';
    color: #1F1F1F;
    font-weight: normal;
  }
  .contain-box-agente .box-icon-agente img, .contain-box-asegurado .box-icon-asegurado img { width: 48px; }
  .contain-box-agente .box-text-agente {
    float: right;
    width: 87%;
  }
  .box-fondo-actual {
    border: #DEDEDE 1px solid;
    border-bottom: 0;
  }
  .box-fondo-actual p span img {
    width: 29px;
    margin-right: 9px;
  }
  #annuity-content .box-fondo-actual p.title-pago-total {
    margin-bottom: 0;
    border-bottom: #DEDEDE 1px solid;
    padding-left: 20px;
    padding-top: 10px;
    padding-bottom: 5px;
    text-align: left;
  }
  .box-fondo-actual p.title-pago-total span span {
    font-family: 'Omnes Medium';
    position: relative;
    bottom: 8px;
  }
  .box-fondo-actual p.main-pago-total {
    color: #717285;
    margin-bottom: 0;
    padding: 36px 25px 29px 20px;
    line-height: 1;
    font-size: 15px;
    display: inline-block;
    width: 100%;
  }
  .box-fondo-actual p.main-pago-total span {
    float: left;
    position: relative;
    top: 8px;
    display: flex;
    align-items: center;
  }
  .box-fondo-actual p strong {
    float: right;
    color: #242424;
    font-size: 30px;
  }
  ul.list-datos-vida {
    list-style: none;
    list-style-image: none;
    list-style-type: none;
    padding: 0;
    border: #DEDEDE 1px solid;
    border-top: 0;
  }
  ul.list-datos-vida li {
    clear: both;
    display: inline-block;
    width: 100%;
    border-top: #DEDEDE 1px solid;
    padding: 18px 0 6px 0;
  }
  ul.list-datos-vida li:last-child {
    padding-bottom: 3px
  }
  ul.list-datos-vida li p.list-title {
    color: #242424;
    margin-bottom: 0;
    margin-left: 20px;
    float: left;
  }
  ul.list-datos-vida li p.list-title img {
    width: 29px;
  }
  ul.list-datos-vida li p.list-title span {
    position: relative;
    bottom: 10px;
    padding-left: 10px;
    font-family: 'Omnes Medium';
  }
  ul.list-datos-vida li p.list-data {
    color: #717285;
    margin-bottom: 0;
    float: right;
    margin-right: 25px;
  }
  /* DESCARGAR POLIZA / CONSTANCIA DE JUBILACION */
  .contain-poliza-electronica {
    padding-top: 2em;
    padding-bottom: 3em;
  }
  .contain-poliza-electronica h3 {
    font-size: 20px;
    margin-bottom: 1.5em;
  }
  .contain-poliza-electronica .box-btn-descargar {
    clear: both;
    overflow: hidden;
    border-top: #DEDEDE 1px solid;
  }
  .contain-poliza-electronica div.box-btn-descargar:first-of-type + div.box-btn-descargar {
    border-bottom: #DEDEDE 1px solid;
  }
  .contain-poliza-electronica .box-btn-descargar p {
    float: left;
    margin-bottom: 0;
    padding-top: 1em;
  }
  .contain-poliza-electronica .box-btn-descargar button {
    float: right;
    background-color: transparent !important;
    box-shadow: none !important;
  }
  .contain-poliza-electronica .box-btn-descargar button:focus:before, .contain-poliza-electronica .box-btn-descargar button:hover:before {
    background-color: transparent !important;
  }
  .contain-poliza-electronica .box-btn-descargar button .v-btn__content img {
    width: 30px;
    height: auto;
  }
  /** DATOS DE ASEGURADO */
  #data-asegurado-agente .v-expansion-panel { padding: 0; }
  #data-asegurado-agente .v-expansion-panel li.v-expansion-panel__container { margin-bottom: 0; }
  #data-asegurado-agente .v-expansion-panel li:first-child .v-expansion-panel__header {
    border-radius: 0;
    background-color: #EFF9FE;
    color: var(--second-brand-color);
    font-size: 18px;
  }
  #data-asegurado-agente .v-expansion-panel li:first-child .v-expansion-panel__header .v-expansion-panel__header__icon i {
    color: var(--second-brand-color) !important;
    background-color: transparent;
    font-size: 30px;
  }
  #data-asegurado-agente .v-expansion-panel li:first-child + li .v-expansion-panel__header {
    background-color: #E1E8F4;
    border-radius: 0;
    color: var(--first-brand-color);
  }
  #data-asegurado-agente .v-expansion-panel li:first-child + li .v-expansion-panel__header .v-expansion-panel__header__icon i {
    color: var(--first-brand-color) !important;
    background-color: transparent;
    font-size: 30px;
  }
  /** HISTORICO DE PAGOS */
  #data-asegurado-agente .v-expansion-panel li:first-child + li + li .v-expansion-panel__header {
    background-color: #E1E8F4;
    border-radius: 0;
    color: var(--first-brand-color);
  }
  #data-asegurado-agente .v-expansion-panel li:first-child + li + li .v-expansion-panel__header .v-expansion-panel__header__icon i {
    color: var(--first-brand-color) !important;
    background-color: transparent;
    font-size: 30px;
  }
  #data-asegurado-agente .v-expansion-panel li:first-child + li + li .v-expansion-panel__body .v-sheet .v-card__text .contain-box-pagos .layout .flex .v-input {
    padding: 12px 16px 0 16px;
  }
  #data-asegurado-agente .v-expansion-panel li:first-child + li + li .v-expansion-panel__body .v-sheet .v-card__text .contain-box-pagos .layout .flex .v-input .v-input__control .v-input__slot .v-select__slot .v-input__append-inner .v-input__icon i {
    background-color: var(--fuchsia-color);
    color: #FFF;
    border-radius: 18px;
  }
  #data-asegurado-agente .v-expansion-panel li:first-child + li + li .v-expansion-panel__body .v-sheet .v-card__text .contain-box-pagos .layout .flex-selected-year p {
    color: #1F1F1F;
    font-family: 'Omnes Medium';
    font-size: 18px;
    font-weight: normal;
    padding-left: 1em;
    text-align: left;
    margin-top: 1em;
    margin-bottom: 1em;
  }
  #data-asegurado-agente .v-expansion-panel li:first-child + li + li .v-expansion-panel__body .v-sheet .v-card__text .contain-box-pagos .layout .history-payments-list .v-list a.v-list__title {
    border: #DEDEDE 1px solid;
    padding: 0;
    margin: 1px 16px;
  }
  #data-asegurado-agente .v-expansion-panel li:first-child + li + li .v-expansion-panel__body .v-sheet .v-card__text .contain-box-pagos .layout .history-payments-list .v-list a.v-list__title .v-list__tile__content .v-list__tile__title { margin-left: 1em; }
  #data-asegurado-agente .v-expansion-panel li:first-child + li + li .v-expansion-panel__body .v-sheet .v-card__text .contain-box-pagos .layout .history-payments-list .v-list a.v-list__title .v-v-list__tile__action button { margin: 6px; }
  #data-asegurado-agente .v-expansion-panel li:first-child + li + li .v-expansion-panel__body .v-sheet .v-card__text .contain-box-pagos .layout .history-payments-list .v-list a.v-list__title .v-v-list__tile__action button .v-btn__content img { width: 100%; }
  .contain-estado-cuenta .layout .flex .v-dialog__container .v-dialog__activator .v-text-field .v-input__control .v-text-field__details { display: none; }
  /** ESTILO 3 */
  /* Small to large handset ----------- */
  @media only screen and (max-width : 600px) {
    /** NEW STYLE V3 */
    #data-asegurado-agente { padding-top: 0 }
    ul.list-datos-vida li:last-child { border-bottom: 0;  }
    .box-fondo-actual p span img, .box-fondo-actual p span span { display: inline; }
    /** BENEFICIARIO / AGENTE */
    .contain-box-agente .box-icon-agente, .contain-box-asegurado .box-icon-asegurado {
      width: 20%;
      padding-left: 0;
      text-align: center;
      position: initial;
    }
    #annuity-content .contain-box-asegurado p { margin-top: 0; }
    #annuity-content .contain-box-agente .box-text-agente, #annuity-content .contain-box-asegurado .box-text-asegurado {
      width: 80%;
      float: right;
    }
    #annuity-content .contain-box-agente .box-text-agente span, #annuity-content .contain-box-asegurado .box-text-asegurado span { font-size: 18px; }
    #annuity-content .contain-box-agente .box-text-agente span, #annuity-content .contain-box-asegurado .box-text-asegurado p { padding-left: 0; }
    #annuity-content .contain-box-asegurado .box-text-asegurado p { margin-bottom: 0; }
    #annuity-content .contain-box-asegurado { border-top: #DEDEDE 12px solid; }
    #annuity-content .contain-poliza-electronica {
      border-top: #DEDEDE 12px solid;
      padding-top: 1em;
      margin-top: 0;
    }
    #annuity-content .contain-poliza-electronica h3 {
      margin-bottom: 1em;
      padding-left: 1em;
    }
    #data-asegurado-agente .contain-poliza-electronica .box-btn-descargar p { padding-top: 11px; }
    .v-btn.download-btn-files, #btnDownloadEstado {
      background-color: var(--fuchsia-color) !important;
      color: #fff;
      -webkit-border-radius: 5px;
      -moz-border-radius: 5px;
      border-radius: 5px;
      height: auto;
      width: 100%;
      margin: 0;
      text-transform: none;
      padding: 10px 0;
    }
    #btnDownloadEstado.v-btn.v-btn--disabled {
      background-color: rgba(0,0,0,.12)!important;
    }
    /** BENEFICIARIO / AGENTE */
    #annuity-content .container { padding: 0; }
    .v-dialog--fullscreen #annuity-content { padding: 16px 0 0 0; }
    #annuity-content h2 {
      font-weight: normal;
      font-size: 20px;
      margin-top: 0;
    }
    #annuity-content p {
      font-size: 17px;
    }
    .subheader-policyinfo img.icon-cliente {
      width: 44px;
      position: relative;
      top: 5px;
      left: 5px;
    }
    .subheader-policyinfo .text-client-policy { padding: 0 !important; }
    .subheader-policyinfo {
      margin-bottom: 0 !important;
      padding-bottom: 0;
    }
    .layout.subheader-policyinfo .flex.first:first-child {
      padding: 7px 16px 24px 16px;
    }
    #annuity-content .layout.subheader-policyinfo .flex.global-info-policy {
      padding: 8px 16px;
      border-top: #DEDEDE 1px solid;
    }
    #annuity-content .layout.subheader-policyinfo .flex.global-info-policy p:first-child {
      padding: 0;
      float: left;
      margin: 0;
      text-align: left;
    }
    #annuity-content .layout.subheader-policyinfo .flex.global-info-policy p:first-child + p {
      padding: 0;
      float: right;
      margin: 0;
      text-align: left;
    }
    .box-fondo-actual { border: none; }
    .box-fondo-actual p {
      text-align: center;
      padding: 30px 25px 0 20px;
    }
    .box-fondo-actual p.main-pago-total span {
      position: initial;
      display: flex;
      justify-content: center;
      align-items: center;
      /* display: block; */
      width: 100%;
      margin-bottom: 10px;
      font-size: 20px;
    }
    .box-fondo-actual p strong {
      position: initial;
      display: block;
      width: 100%;
      font-size: 32px;
    }
    #annuity-content ul.list-datos-vida li p.list-title {
      margin-left: 0;
      padding-left: 15px;
    }
    #annuity-content ul.list-datos-vida li p.list-data {
      padding-left: 0;
      padding-right: 0;
      margin-right: 23px;
    }
    #annuity-content .contain-box-asegurado p {
      padding-left: 0;
    }
    .contain-box-asegurado p img {
      width: 21px;
      position: initial;
      margin-right: 18px;
    }
    #annuity-content .contain-box-agente {
      display: inline-block;
      width: 100%;
      margin-top: 1.5em;
      border-top: #DEDEDE 12px solid;
      border-bottom: 0;
    }
    #annuity-content .contain-box-agente .box-text-agente span {
      color: #1F1F1F;
      font-family: 'Omnes Medium';
      font-size: 18px;
    }
    #annuity-content .contain-box-agente .box-text-agente p.name-agente { padding-left: 0; }
    #annuity-content .contain-box-agente .box-text-agente p.email-agente {
      color: #fff;
      border: #0855C4 1px solid;
      background-color: #0855C4;
      width: 90%;
      display: flex;
      padding-top: 10px;
      padding-bottom: 10px;
    }
    #annuity-content .contain-box-agente .box-text-agente p.email-agente span {
      color: #FFF;
      font-size: 12px;
    }
    .history-payments-list .v-list div[role="listitem"] {
      border: #DEDEDE 1px solid;
      border-radius: 30px;
      margin-left: 10px;
      margin-right: 10px;
    }
    .history-payments-list .v-list div[role="listitem"] a .v-list__tile__action button .v-btn__content img { width: 100%; }
    .flex-selected-year div[role="combobox"] {
      margin-top: 20px;
      margin-left: 17px;
      margin-right: 17px;
    }
    /** NEW STYLE V3 */
  }
  /* Large tablet to laptop ----------- */
  @media only screen  and (min-width : 961px) and (max-width: 1264px) {}

  /* Desktop ----------- */
  @media only screen  and (min-width : 1265px) {
    #annuity-content .contain-box-agente p.email-agente img {
      position: relative;
      top: 2px;
    }
    #annuity-content .contain-box-agente .box-text-agente .name-agente { margin-bottom: 5px; }
    #annuity-content ul.v-expansion-panel.theme--light li.v-expansion-panel__container .v-expansion-panel__header {
      border-radius: 0;
      background-color: transparent;
      font-family: 'Omnes Regular';
      color: #242424;
      font-weight: bold;
      padding-left: 0;
      padding-right: 39px;
      margin-bottom: 1em;
    }
    #annuity-content ul.v-expansion-panel.theme--light li.v-expansion-panel__container .v-expansion-panel__body .v-card .v-card__text .contain-box-pagos .row .history-payments-list .v-list a.v-list__tile--link { padding: 0 0 0 10px; }
    #annuity-content ul.v-expansion-panel.theme--light li.v-expansion-panel__container .v-expansion-panel__body .v-card .v-card__text .contain-box-pagos .row .history-payments-list .v-list a.v-list__tile--link .v-list__tile__action { justify-content: center; }
    #annuity-content ul.v-expansion-panel.theme--light li.v-expansion-panel__container .v-expansion-panel__body .v-card .v-card__text .contain-box-pagos .row .history-payments-list .v-list__tile__action button .v-btn__content img {
      width: 100%;
    }
    #annuity-content ul.v-expansion-panel.theme--light li.v-expansion-panel__container .v-expansion-panel__body .v-card .v-card__text .contain-box-pagos .row .history-payments-list .v-list {
      border: #DEDEDE 1px solid;
      border-radius: 11px;
      padding: 0;
      width: 92%;
    }
    #annuity-content ul.v-expansion-panel.theme--light li.v-expansion-panel__container .v-expansion-panel__body .v-card .v-card__text .contain-box-pagos .row .history-payments-list { padding: 5px 0; }
  }
</style>



// WEBPACK FOOTER //
// src/components/FormAnnuity.vue